import React from 'react'

import { connect } from "react-redux"

// need to use withRouter higher order component to access the routing history since the Lobbyist actions isn't a route
// we could pass in as props from parent but this makes it stand alone
import { withRouter } from 'react-router'

import { Form } from 'react-form'

import { Message } from 'primereact/message'

import CompanyDetails from '../components/lobbyist/company-details'
import AnnualReturnClient from '../container/AnnualReturnClient'
import AnnualReturnEmployee from '../container/AnnualReturnEmployee'
import AnnualReturnActions from './AnnualReturnActions'
import RedactedDetails from '../components/common/RedactedDetails'
import { Card } from 'primereact/card'
import FieldInputTextarea from '../components/common/FieldInputTextarea'

import { ANNUAL_RETURN_STATUS_AWAITING_APPROVAL, ANNUAL_RETURN_STATUS_AWAITING_SUBMIT, ANNUAL_RETURN_STATUS_APPROVED, ROLE_ADMIN } from '../js/const'

import { formatDate } from '../js/utils'

import * as annualReturnClientActionCreators from "../actionCreators/annualReturnClient"
import * as annualReturnEmployeeActionCreators from "../actionCreators/annualReturnEmployee"
import * as annualReturnActionCreators from "../actionCreators/annualReturn"
import * as appActionCreators from "../actionCreators/app"
import * as systemParameterActionCreators from "../actionCreators/systemParameter"

import '../css/annual-return.css'

const ChangesRequired = ({ showAsTextOnly, validationRules }) => {
  return (
    <Card title="Requested Changes">
      <div className="p-grid">
        <div className="p-col-12 p-md-12 p-lg-12">
          <FieldInputTextarea style={{ background: "wheat" }} rows={3} field={"ChangesRequired"} label={"Changes Required"} validationRules={validationRules} showAsTextOnly={showAsTextOnly} />
        </div>
      </div>
    </Card>
  )
}

class AnnualReturn extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // flag stored at container level because we want to know when the container itself has loaded so we can hide/show based on that
      // this way any loading done by child components doesn't cause the container to be hidden
      hasLoaded: false
    }
  }

  componentDidMount() {
    //is invoked immediately after a component is mounted. 
    //Initialization that requires DOM nodes should go here. If you need to load data from a remote endpoint, this is a good place to instantiate the network request.  
    this.loadAnnualReturn(this.props.match.params.annualReturnId)
  }

  // check if component is required to be updated if parameter has changed because going from one lobbyist to another doesn't make the component re mount
  componentDidUpdate(prevProps) {
    let previousAnnualReturnId = prevProps.match.params.annualReturnId
    let annualReturnId = this.props.match.params.annualReturnId

    // reload lobbyist if parameter has changed
    if (previousAnnualReturnId !== annualReturnId) {
      this.loadAnnualReturn(annualReturnId)
    }
  }

  loadAnnualReturn = annualReturnId => {
    let lobbyistId = this.props.match.params.lobbyistId

    // is invoked immediately after a component is mounted. 
    // Initialization that requires DOM nodes should go here. If you need to load data from a remote endpoint, this is a good place to instantiate the network request.   
    this.props.setLoading(true)
      .then(() => this.props.getAnnualReturn(lobbyistId, annualReturnId))
      .then(() => {
        // check if current annualReturn that is being looked at exists. If not create an empty object to deal with issues that could be caused by annualReturn being undefined
        let currentAnnualReturn = this.props.annualReturn.currentAnnualReturn ? this.props.annualReturn.currentAnnualReturn : {}

        // store the promises in an array so we can kick off loading at the same time but it won't continue until all the loading has finished
        let dataloadPromises = []
        dataloadPromises.push(this.props.getClientsForAnnualReturn(lobbyistId, currentAnnualReturn))
        dataloadPromises.push(this.props.getEmployeesForAnnualReturn(lobbyistId, currentAnnualReturn))
        dataloadPromises.push(this.props.getDPCNotificationEmail())
        return Promise.all(dataloadPromises)
      })
      .then(() => this.props.setLoading(false))
      .then(() => {
        this.setState({ hasLoaded: true })
      })
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false))
      )
  }

  // third step is annual return submitting for approval
  submitAnnualReturn = annualReturn => {
    this.props.setLoading(true)
      .then(() => {
        this.props.submitAnnualReturn(annualReturn)
          .then(response => {
            this.props.setAjaxResponse(response)
            this.props.setLoading(false)
          })
      })
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  updateAnnualReturn = annualReturn => {
    this.props.setLoading(true)
      .then(() => {
        this.props.updateAnnualReturn(annualReturn)
          .then(response => {
            this.props.setAjaxResponse(response)
            this.props.setLoading(false)
          })
      })
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  submitOrUpdateAnnualReturn = annualReturn => 
  {
    if(annualReturn.StatusCode === ANNUAL_RETURN_STATUS_APPROVED)
    {
      this.updateAnnualReturn(annualReturn);
    }
    else
    {
      this.submitAnnualReturn(annualReturn);
    }
  }

  render() {
    // check if current annualReturn that is being looked at exists. If not create an empty object to deal with issues that could be caused by annualReturn being undefined
    let currentAnnualReturn = this.props.annualReturn.currentAnnualReturn ? this.props.annualReturn.currentAnnualReturn : {}

    let isAuthenticated = this.props.auth.isAuthenticated
    let isAdmin = this.props.auth.roles && this.props.auth.roles.some(role => role === ROLE_ADMIN)

    let lobbyistId = this.props.match.params.lobbyistId
    let annualReturnId = currentAnnualReturn.AnnualReturnId

    let isAwaitingApproval = currentAnnualReturn.StatusCode === ANNUAL_RETURN_STATUS_AWAITING_APPROVAL
    let isAwaitingSubmit = currentAnnualReturn.StatusCode === ANNUAL_RETURN_STATUS_AWAITING_SUBMIT
    //let isApproved = currentAnnualReturn.StatusCode === ANNUAL_RETURN_STATUS_APPROVED
    
    let isAdd = !currentAnnualReturn.AnnualReturnId
    let isCorrectLobbyist = currentAnnualReturn.LobbyistId === this.props.auth.lobbyistId
    
    let canSave = (isAdd === false && isAuthenticated === true && (isAdmin === true || (isCorrectLobbyist && isAwaitingSubmit === true))) || isAdd
    let canSeePrivateData = (isAdd === false && isAuthenticated === true && (isAdmin === true || isCorrectLobbyist)) || isAdd
    let showAsTextOnly = canSave === false
    let validationRules = currentAnnualReturn.ValidationRules ? currentAnnualReturn.ValidationRules.$values : []
    let dpcEmail = this.props.systemParameter.dpcNotificationEmail
    let redactionMessage = <span>
      <a href={`mailto:${dpcEmail}?subject=Re:%20SA%20Lobbyist%20Register`}>Contact the SA Lobbyist Register team</a> if you wish any of your information (e.g. personal address) to remain private.
    </span>

    let previousChangesRequired = currentAnnualReturn.ChangesRequired
    return (
      /* values sets the form state. I'm binding to the props which is linked redux so we can update the store and the form will be reflected
      this is useful when needed to clear the form or populating the form from another component
      onSubmit is called when the form has been submitted and has passed validation
      formApi properties can be found at https://react-form.js.org/#/*/
      <Form values={currentAnnualReturn} onSubmit={this.submitOrUpdateAnnualReturn}>
        {formApi => {
          return (
            <div className="annual-return-details">
              {this.state.hasLoaded &&(isAwaitingSubmit || isAwaitingApproval) && previousChangesRequired && <ChangesRequired isAdd={isAdd} showAsTextOnly={showAsTextOnly} validationRules={validationRules} />}
              {this.state.hasLoaded &&<h1>{currentAnnualReturn.TypeDescription} {formatDate(currentAnnualReturn.StartDate)} - {formatDate(currentAnnualReturn.EndDate)}</h1>}
              {this.state.hasLoaded &&
                <CompanyDetails 
                  isAdd={isAdd} 
                  canSave={canSave} 
                  showAsTextOnly={true} 
                  validationRules={validationRules} 
                  isAuthenticated={isAuthenticated} 
                  formName="AnnualReturn" 
                  // pass current values from formApi
                  LobbyistsNoConvictions={formApi.values.LobbyistsNoConvictions}
                  LobbyistsYesConvictions={formApi.values.LobbyistsYesConvictions}
                  LobbyistsConvictionDetails={formApi.values.LobbyistsConvictionDetails}
                  // callback to update the shared form state
                  onPropChange={(fieldName, value) => {
                      formApi.setValue(fieldName, value);
                  }}
                  />}
              {this.state.hasLoaded && isAdmin &&<RedactedDetails showAsTextOnly={showAsTextOnly} validationRules={validationRules} />}
              {this.state.hasLoaded && isAdd === false && <AnnualReturnEmployee canSave={canSave} canSeePrivateData={canSeePrivateData} lobbyistId={lobbyistId} annualReturnId={annualReturnId} />}
              {this.state.hasLoaded && isAdd === false && <AnnualReturnClient canSave={canSave} lobbyistId={lobbyistId} annualReturnId={annualReturnId} currentAnnualReturn={currentAnnualReturn} />}
              {this.state.hasLoaded && isAdd === false && isAwaitingSubmit === true && <div className="p-col-12 p-md-12 p-lg-12">
                  <Message style={{ width: '100%' }} severity="info">{redactionMessage}</Message>
                </div>}
              {this.state.hasLoaded &&<AnnualReturnActions formApi={formApi} />}
            </div>
          )
        }
        }
      </Form>
    )
  }
}

const mapStateToProps = state => {
  let { annualReturn, auth, systemParameter } = state
  return { annualReturn, auth, systemParameter }
}

// this is how to combine actions available
const actionCreators = {
  ...annualReturnClientActionCreators,
  ...annualReturnEmployeeActionCreators,
  ...annualReturnActionCreators,
  ...appActionCreators,
  ...systemParameterActionCreators
}

export default withRouter(connect(mapStateToProps, actionCreators)(AnnualReturn))


// WEBPACK FOOTER //
// ./src/container/AnnualReturn.js